import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { GlobalContextProvide } from './ContextHooks/GlobalContextProvide';
import './scss/_app.scss';
import Routes from './Routes/Routes';
import 'rsuite/dist/rsuite.min.css';
import { Toaster } from 'react-hot-toast';

const App = () => {
  return (
    <>
      <Toaster position="right-top" reverseOrder={false} />
      <GlobalContextProvide>
        <Routes />
      </GlobalContextProvide>
    </>
  );
};

export default App;
